import { formatTime } from "./formatTime";

export const formatValue = (value, timed) => {
  return timed ? formatTime(value) : value;
};
